import React from 'react';

const EmbedFrame = ({ src, title = 'Embedded content' }) => (
    <iframe
        src={src}
        title={title}
        style={{
            width: '100%',
            height: '100%',
            border: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }}
        allowFullScreen
    />
);

export default EmbedFrame;
